import { render, staticRenderFns } from "./IdentificationDateOfInput.vue?vue&type=template&id=004b5472&"
import script from "./IdentificationDateOfInput.vue?vue&type=script&lang=js&"
export * from "./IdentificationDateOfInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports